"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _PromptablePropInterface = _interopRequireDefault(require("UIComponents/decorators/PromptablePropInterface"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

var RejectConfirmationModal = function RejectConfirmationModal(_ref) {
  var optState = _ref.optState,
      onConfirm = _ref.onConfirm,
      onReject = _ref.onReject;
  return _react.default.createElement(_UIConfirmModal.default, {
    message: _react.default.createElement(_FormattedMessage.default, {
      message: "ui-addon-opt.rejectConfirmationModal.message"
    }),
    description: _react.default.createElement(_FormattedMessage.default, {
      message: "ui-addon-opt.rejectConfirmationModal.description." + optState
    }),
    rejectLabel: _react.default.createElement(_FormattedMessage.default, {
      message: "ui-addon-opt.rejectConfirmationModal.reject"
    }),
    confirmLabel: _react.default.createElement(_FormattedMessage.default, {
      message: "ui-addon-opt.rejectConfirmationModal.confirm"
    }),
    onConfirm: onConfirm,
    onReject: onReject,
    size: "auto"
  });
};

RejectConfirmationModal.propTypes = (0, _extends2.default)({
  optState: _react.PropTypes.oneOf(['OPTED_IN', 'OPTED_OUT', 'AVAILABLE'])
}, _PromptablePropInterface.default);

var _default = (0, _Promptable.default)(RejectConfirmationModal);

exports.default = _default;
module.exports = exports.default;